import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function PublicHearing(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Social Audit Public Hearing</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
                <Downloader url={"pdf/public_hearing/SAPH_2016-2017.pdf"} name={"Social Audit Public Hearing during the Financial Year 2016 - 2017"}/> 
                <Downloader url={"pdf/public_hearing/SAPH_2015-2016.pdf"} name={"Social Audit Public Hearing during the Financial Year 2015 - 2016 "}/> 
            </Box>
        </Box>
    )
}